export const GUINCHO_HIDRAULICO_GH1000 = {
    Codigo: 7,
    Nome: 'Guincho Hidráulico GH-1000',
    Modelo: 'GH-1000',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Guincho GH-1000 Hidráulico/guincho_hid_gh1000_1.png"
        }
    ],
    Detalhes: [
        `Capacidade 1000 Kg`,
        `Altura de levante 4 metros`
    ],
    Modelos: [
        { Modelo: 'GH-1000', Detalhes:	'' }
    ]
}